/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsVideo = {
  init: function ($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsVideo = $.extend(this, window.PXUTheme.getSectionData($section));

    // Selectors
    const $videoElement = $section.find('[data-video-element]');
    const $playIcon = $section.find('.plyr--paused.plyr--video .plyr__control--overlaid');
    const $playButton = $section.find('[data-play-button]');
    const $videoTextContainer = $section.find('[data-video-text-container]');
    const $imageElement = $section.find('.video-wrapper [data-image-element]');

    if (this.defer_html5_autoplay && this.html5_video) {
      this.loadDeferredHtml5Video($section, $videoElement, $imageElement, $videoTextContainer);
      return;
    }

    if (!this.iframe_video && this.html5_video && this.controls) {
      this.loadNativeHtml5Video($section, $videoElement, $imageElement, $videoTextContainer);
      return;
    }

    // Load video if the media has been added
    if (this.iframe_video || this.html5_video) {
      this.loadVideo($videoElement, $playIcon, $playButton, $videoTextContainer, $imageElement);
    } else {
      $imageElement.show();
    }

  },
  loadNativeHtml5Video: function($section, $videoElement, $imageElement, $videoTextContainer) {
    this.setActiveResponsiveVideo($section);
    $imageElement.hide();
    $videoTextContainer.show();
    $videoElement.show();

    $section.find('.video-element video').off('click.nativeHtml5Video').on('click.nativeHtml5Video', function(event) {
      if (!isScreenSizeLarge()) return;

      const controlsHeight = 48;
      const rect = this.getBoundingClientRect();
      const clickedControls = event.clientY >= rect.bottom - controlsHeight;

      if (clickedControls) return;

      event.preventDefault();

      if (this.paused) {
        this.play();
      }
      else {
        this.pause();
      }
    });
  },
  loadDeferredHtml5Video: function($section, $videoElement, $imageElement, $videoTextContainer) {
    const sectionId = $section.attr('id');
    const eventName = `load.jsVideo-${sectionId}`;

    if ($section.data('js-video-deferred-init')) return;
    $section.data('js-video-deferred-init', true);

    this.setActiveResponsiveVideo($section);
    $imageElement.hide();
    $videoTextContainer.show();

    const playVideo = () => {console.log('Playing video');
      const videos = $section.find('.video-element video').toArray();

      videos.forEach((video) => {
        if (!video.offsetParent) return;

        video.muted = true;
        video.defaultMuted = true;
        video.setAttribute('muted', '');
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.volume = 0;
        video.preload = 'auto';

        const playPromise = video.play();
        if (playPromise) {
          playPromise.catch(() => {});
        }
      });
    };

    const schedulePlay = () => {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(playVideo, { timeout: 300 });
      } else {
        setTimeout(playVideo, 300);
      }
    };

    if (document.readyState === 'complete') {
      schedulePlay();
    } else {
      $(window).off(eventName);
      $(window).one(eventName, schedulePlay);
    }
  },
  setActiveResponsiveVideo: function($section) {
    const isMobile = window.matchMedia('(max-width: 480px)').matches;
    const $desktopVideo = $section.find('.video-element--desktop');
    const $mobileVideo = $section.find('.video-element--mobile');

    if ($mobileVideo.length) {
      $desktopVideo.each(function() {
        this.style.setProperty('display', isMobile ? 'none' : 'block', 'important');
      });

      $mobileVideo.each(function() {
        this.style.setProperty('display', isMobile ? 'block' : 'none', 'important');
      });
    }
  },
  loadVideo: function($videoElement, $playIcon, $playButton, $videoTextContainer, $imageElement) {
    const player = new Plyr(`.video-${this.id}`, {
      controls: this.controls ? videoControls : [],
      loop: {
        active: this.autoloop
      },
      fullscreen: {
        enabled: true,
        fallback: true,
        iosNative: true
      },
      storage: {
        enabled: false
      }
    });

    player.muted = this.mute;
    player.ratio = this.aspect_ratio;

    // If autoplay enabled, hide image and text
    if (this.autoplay) {
      player.autoplay = true;
      $imageElement.hide();
      $videoTextContainer.hide();
      $videoElement.show();
    } else {
      // If autoplay disabled, check if poster image added
      if (this.poster && $imageElement.length && this.iframe_video) {
        console.log('Hiding video element, showing image and text');
        $videoElement.hide();
        $imageElement.show();
        $videoTextContainer.show();
      } else {
        // If autoplay disabled and no poster image
        $imageElement.hide();
        $videoElement.show();
        $videoTextContainer.show();
      }
    }

    // If button exists, clicking button will play video
    if (this.button) {
      $playButton.on('click', () =>  {
        player.play();
      })
    }

    // Clicking anywhere on video should play the video
    if (!this.button) {
      $videoTextContainer.on('click', () => {
        player.play();
      })
    }

    // If on mobile and text is below image, clicking the image wrapper should play the video
    if (!isScreenSizeLarge() && $videoElement.parents('.mobile-text--below-media')) {
      $imageElement.on('click', () => {
        player.play();
      })
    }

    // On player ready, hide play icon if play button visible
    player.on('ready', function(index, player) {
      if ($playButton && !isScreenSizeLarge() && $videoElement.parents('.mobile-text--below-media')) {
        $playIcon.show();
      } else if ($playButton) {
        $playIcon.hide();
      } else {
        $playIcon.show();
      }
    })

    // On play, hide image/text and show video element
    player.on('play', function(index, player) {
      $videoElement.show();
      $imageElement.hide();
      $videoTextContainer.hide();
    })

    // On player pause, show play icon if play button hidden
    player.on('pause', function(index, player) {
      if (!$playButton) {
        $playIcon.show();
      }
    })

  },
  unload: function($section) {
    const $playButton = $section.find('[data-play-button]');
    const $videoTextContainer = $section.find('[data-video-text-container]');
    const sectionId = $section.attr('id');

    $playButton.off();
    $videoTextContainer.off();
    $section.find('.video-element video').off('click.nativeHtml5Video');
    $(window).off(`load.jsVideo-${sectionId}`);
    $section.removeData('js-video-deferred-init');
  }
}

/******/ })()
;
